import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logsByKey: {}, // key = `${mode}-${playerId}-${year}-${month}`
};

const ptLogsSlice = createSlice({
  name: "ptLogs",
  initialState,
  reducers: {
    setLogs(state, action) {
      const { key, logs } = action.payload;
      state.logsByKey[key] = logs;
    },
    addLog(state, action) {
      const { key, log } = action.payload;
      if (state.logsByKey[key]) {
        state.logsByKey[key].unshift(log);
      }
    },
    updateLog(state, action) {
      const { oldKey, newKey, logId, updatedLog } = action.payload;

      // Remove from old cache
      if (state.logsByKey[oldKey]) {
        state.logsByKey[oldKey] = state.logsByKey[oldKey].filter(
          (log) => log.id !== logId
        );

        // if empty → remove the key completely
        if (state.logsByKey[oldKey].length === 0) {
          delete state.logsByKey[oldKey];
        }
      }

      // Insert into new cache
      if (!state.logsByKey[newKey]) {
        state.logsByKey[newKey] = [];
      }

      state.logsByKey[newKey].unshift({
        id: logId,
        ...updatedLog,
      });
    },
    deleteLog(state, action) {
      const { key, logId } = action.payload;
      if (!state.logsByKey[key]) return;

      state.logsByKey[key] = state.logsByKey[key].filter(
        (log) => log.id !== logId
      );
    },
    clearLogs(state, action) {
      const { key } = action.payload;
      delete state.logsByKey[key];
    },
  },
});

export const { setLogs, addLog, updateLog, deleteLog, clearLogs } =
  ptLogsSlice.actions;

export default ptLogsSlice.reducer;
